"use strict";

import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";
import React from "react";

const DialogueRatingSourceSelector = ({
    useOriginalAudioRating,
    onChange,
}) => (
    <FormControl size="small" sx={{ minWidth: 190 }}>
        <InputLabel id="dialogue-rating-source-label">
            Dialogue ratings
        </InputLabel>
        <Select
            labelId="dialogue-rating-source-label"
            aria-label="Dialogue rating source"
            label="Dialogue ratings"
            value={useOriginalAudioRating ? "manual" : "auto"}
            onChange={(event) => onChange(event.target.value === "manual")}
        >
            <MenuItem value="auto">Auto dialogue ratings</MenuItem>
            <MenuItem value="manual">Manual dialogue ratings</MenuItem>
        </Select>
    </FormControl>
);

export default DialogueRatingSourceSelector;
